export const getDaysLeft = (expDate) => {
  const todayMiliseconds = new Date().getTime();
  const expMiliseconds = new Date(expDate).getTime();
  const hoursLeft = Math.floor(
    (expMiliseconds - todayMiliseconds) / 1000 / 60 / 60
  );
  const daysLeft = Math.round(hoursLeft / 24);

  return expDate
    ? { days: daysLeft === 0 ? 1 : daysLeft, hours: hoursLeft }
    : {};
};
